<template>
  <el-drawer title="作品指标历史" :visible="visible" size="52%" @close="close">
    <div class="body" v-loading="loading">
      <el-descriptions v-if="item" :column="1" border size="small">
        <el-descriptions-item label="作品">{{ item.title || item.source_id }}</el-descriptions-item>
        <el-descriptions-item label="平台">{{ item.platform }}</el-descriptions-item>
      </el-descriptions>
      <el-table :data="metrics" empty-text="暂无指标历史" class="mt" :default-sort="{ prop: 'captured_at', order: 'descending' }">
        <el-table-column prop="display_name" label="指标" />
        <el-table-column label="数值"><template slot-scope="scope">{{ valueText(scope.row) }}</template></el-table-column>
        <el-table-column prop="availability" label="数据状态" />
        <el-table-column prop="captured_at" label="采集时间" width="180" sortable :sort-method="sortByCapturedAt" />
      </el-table>
    </div>
  </el-drawer>
</template>
<script>
import { yuqingApi } from '@/api/yuqing'
export default {
  props: ['visible', 'item'], data () { return { loading: false, metrics: [] } },
  watch: { visible (value) { if (value && this.item) this.load() } },
  methods: {
    async load () { this.loading = true; this.metrics = []; try { const metrics = (await yuqingApi.get(`creator-content/${this.item.id}/metrics`)).metrics || []; this.metrics = metrics.slice().sort((left, right) => this.sortByCapturedAt(right, left)) } catch (error) { this.$message.error(error.message) } finally { this.loading = false } },
    sortByCapturedAt (left, right) { return this.capturedAtTime(left) - this.capturedAtTime(right) },
    capturedAtTime (item) { const value = item && item.captured_at ? String(item.captured_at).replace(' ', 'T') : ''; const time = Date.parse(value); return Number.isNaN(time) ? 0 : time },
    valueText (item) { return item.availability && item.availability !== 'available' ? '暂不可用' : Number(item.value || 0).toLocaleString('zh-CN') },
    close () { this.metrics = []; this.$emit('update:visible', false) }
  }
}
</script><style scoped>.body{padding:0 20px}.mt{margin-top:16px}</style>
